import React from 'react';

import { ChevronDownMini, ChevronUpMini } from '@xsolla/ui-icons';

import { ISortStatuses } from '../../../hooks/types';
import { ArrowsWrapper, SortElement } from './style';

type Props = {
  collumnName?: string;
  sortStatus?: ISortStatuses;
  onClick: () => void;
};

export const SortArrows = ({ sortStatus, collumnName, onClick }: Props): JSX.Element => {
  return (
    <SortElement onClick={onClick}>
      <ArrowsWrapper
        activeStatus={sortStatus?.order_column === collumnName}
        ascSort={sortStatus?.order_dir === 'asc'}>
        <ChevronUpMini size={18} />
        <ChevronDownMini size={18} />
      </ArrowsWrapper>
    </SortElement>
  );
};
